import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";

const UPDATE_QUANTITY_URL = "orders/updateQuantity";


export const FetchTestBarcode = createAsyncThunk(
  "FetchTestBarcode",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`barcode/getTestBarcode`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateInventoryQuantity = createAsyncThunk(
  "updateInventoryQuantity",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).put(`${UPDATE_QUANTITY_URL}`, values);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);


export const ValidateTestBarcode = createAsyncThunk(
  "ValidateTestBarcode",
  async ({ values }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(`barcode/validateScannedBarcode`, values);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);




